export default "__VITE_ASSET__dc3340a1__"